export default {
  header: 'Accijnsinformatie',
  amountPaid: 'Betaald bedrag',
  datePaid: 'Betaaldatum',
  notPaid: 'Niet betaald',
  paymentReferenceId: 'Betalingsreferentie-ID',
  na: 'N.v.t.',
};
